<div class="dropdown">
  <div class="dropdown-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div class="dropdown-heading">{{ 'NOTIFICATIONS' | translate }}</div>
      <div class="dropdown-subheading">
        {{ 'HAVE_N_NEW_NOTIFICATIONS' | translate : { count: homeNotification.length } }}
      </div>
    </div>

    <!-- <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <mat-icon [icIcon]="icSettings" class="notifications-header-icon"></mat-icon>
    </button> -->
  </div>

  <div class="dropdown-content">
    <div *ngIf="!loader" fxLayout="row" fxLayoutAlign="center center" class="my-2">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <a
      *ngFor="let notification of homeNotification; trackBy: trackById"
      [class.read]="notification.read"
      [routerLink]="[]"
      class="notification"
      fxLayout="row"
      fxLayoutAlign="start center"
      matRipple>
      <i class="fa {{ notification.icon }} fa-2x"></i>

      <!-- <ic-icon [icon]="notification.icon" [ngClass]="notification.colorClass" class="notification-icon" fxFlex="none"
        size="24px"></ic-icon> -->
      <div fxFlex="auto">
        <div class="notification-label ml-3">{{ notification.canname }}</div>
        <div class="notification-label ml-3" [innerHTML]="notification.Notes"></div>
        <div class="notification-description ml-3">
          {{ notification.Enterdate | date : 'd MMMM, y' }}
        </div>
      </div>
      <!-- <mat-icon [icIcon]="icChevronRight" class="notification-chevron" fxFlex="none"></mat-icon> -->
    </a>
  </div>

  <!-- <div class="dropdown-footer" fxLayout="row" fxLayoutAlign="center center">
    <button color="primary" mat-button type="button">MARK ALL AS READ</button>
  </div> -->
</div>
